import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LicenceTab = _resolveComponent("LicenceTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary",
    style: _ctx.licenseDialogDescriptor.card.style,
    visible: _ctx.visibility,
    footer: "footer",
    closable: false,
    modal: ""
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('licenseDialog.title')), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (!_ctx.licenses.hosts || _ctx.licenses.hosts.length === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("p", null, _toDisplayString(_ctx.$t('licenseDialog.noLicenses')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_TabView, { class: "kn-tab" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.licenses.hosts, (host) => {
            return (_openBlock(), _createBlock(_component_TabPanel, {
              key: host.hardwareId
            }, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(host.hostName), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_LicenceTab, {
                  licenses: _ctx.licenses.licenses[host.hostName],
                  host: host,
                  cpunumber: _ctx.licenses.cpuNumber
                }, null, 8, ["licenses", "host", "cpunumber"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}